<template>
    <div class="mt-4 mb-5">
        <div class="row">
            <div class="col-md-12">
                <section v-if="envType === 'live'">
                    <h4>Cloudflare CDN</h4>
                    <p>Cloudflare is one of the world's largest available content delivery and security service
                        that is fully integrated and available at no extra cost to you.</p>
                    <p>Below you will find some options that pertain specifically to cloudflare.</p>
                    <div class="row">
                        <div class="col-sm-12 col-md-3">
                            <br/>
                            <span class="col-mb d-block">
                            Developer Mode:
                            <span data-toggle="tooltip" data-placement="top" style="cursor: pointer" title="Putting your site into developer mode stops the CDN from caching your static content like images, css, javascript.  This will automatically turn off after 3 hours." class="m_tip"><i class="fa fa-question-circle text-primary"></i></span>
                        </span>
                            <select class="form-control-sm" v-model="siteCFDeveloperMode" @change="changeDeveloperMode()">
                                <option value="on">On</option>
                                <option value="off">Off</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-3">
                            <br/>
                            <span class="col-mb d-block">
                            Cloud Flare Status:
                            <span data-toggle="tooltip" data-placement="top" style="cursor: pointer" title="Controls whether or not your traffic will bypass Cloudflare.  We highly recommend never disabling this and instead using Developer mode." class="m_tip"><i class="fa fa-question-circle text-primary"></i></span>
                        </span>
                            <select class="form-control-sm" v-model="siteCF" @change="changeSiteCF" >
                                <option value="enabled">Enabled</option>
                                <option value="disabled">Disabled</option>
                            </select>
                        </div>
                    </div>
                    <hr/>
                </section>
<!--                <h4>WP Rocket Integration</h4>-->
<!--                <p>If you are using the plugin WP Rocket you will want to enable this option to-->
<!--                allow the plugin to work properly with the server.</p>-->
<!--                <p>Before activating this option:</p>-->
<!--                <ul>-->
<!--                    <li>Ensure the plugin is installed and activated.</li>-->
<!--                    <li>Make sure all other caching plugins like cache enabler, w3 total cache-->
<!--                    wp super cache, etc, are disabled.</li>-->
<!--                </ul>-->
<!--                <div class="col-12 mb-2 text-right">-->
<!--                    <button class="btn btn-outline-primary btn-round btn-sm btn-primary mr-3" @click="enableWPRocket()">-->
<!--                        <span>-->
<!--                            Enable-->
<!--                        </span>-->
<!--                    </button>-->
<!--                </div>-->
<!--                <hr/>-->
                <h4>Fix phpMyAdmin</h4>
                <p>If you are having problems accessing phpMyAdmin use this option.  Please note, it may take 2 - 3 minutes for changes to take affect.</p>
                <div class="col-12 mb-2 text-right">
                    <button :disabled="fixPhpMyAdminLoader" class="btn btn-outline-primary btn-round btn-sm btn-primary mr-3" @click="fixPhpMyAdmin">
                        <div v-if="fixPhpMyAdminLoader" class="loader mini_loader"></div>
                        <span v-else>Fix</span>
                    </button>
                </div>
                <hr/>
                <h4>Fix Permissions</h4>
                <p style="margin-bottom: 0">Use this option to fix issues caused by incorrect ownership or file permissions. Example of when to use this:</p>
                <b class="text-danger"><i>update Failed : Could not create directory.</i></b><br/><br/>
                <p>
                    <span class="badge badge-warning mb-0">Please Note</span>
                    Depending on how large your site is, this can take several minutes to complete.
                </p>
                <div class="col-12 mb-2 text-right">
                    <button :disabled="fixPermissionsLoader" class="btn btn-outline-primary btn-round btn-sm btn-primary mr-3" @click="fixPermissions()">
                        <div v-if="fixPermissionsLoader" class="loader mini_loader"></div>
                        <span v-else>
                            Fix
                        </span>
                    </button>
                </div>
                <hr/>
            </div>
        </div>
    </div>
</template>

<script>
    import swal from 'sweetalert2';
    export default {
        name: "Utilities",
        data() {
            return {
                siteCFDeveloperMode: 'off',
                siteCF: 'enabled',
                loader: false,
            }
        },
        computed: {
          allAccounts() {
              return this.$store.getters["hosting/accounts"]
          },
          fixPhpMyAdminLoader() {
              return this.$store.getters.getFixPhpMyAdminLoader;
          },
          fixPermissionsLoader() {
              return this.$store.getters.getFixPermissionsLoader;
          },
          user() {
            return this.$store.getters.user;
          }
        },
        props: {
            account: {
                type: Object,
                required: true
            },
            envType: {
                type: String,
                required: true
            },
            fromCollaborator: {
                type: Boolean,
                required: false
            },
            supervisor: {
                type: Object,
                required: false
            }
        },
        watch: {
            account() {
                console.log('watching...');
                this.fetchSiteCFData(this.account);
            }
        },
        mounted(){
            this.fetchSiteCFData(this.account);
        },
        methods: {
            async changeDeveloperMode() {
                console.log(this.account.cloudflare);
                const account = this.account;
                try{
                    if(this.envType === 'live' && (account.cloudflare.apiKey !== null && account.cloudflare.apiKey !== '')
                        && (account.cloudflare.username !== null && account.cloudflare.username !== '')
                        && (account.cloudflare.zone_id !== null && account.cloudflare.zone_id !== '') ){
                        const zoneDetails = await this.$http.post('provider/development_mode', {
                            user_email: account.cloudflare.username,
                            api_key: account.cloudflare.apiKey,
                            zone_id: account.cloudflare.zone_id,
                            mode: this.siteCFDeveloperMode
                        });
                        const zoneDetailsData = zoneDetails.data;
                        console.log(zoneDetailsData);
                        if(zoneDetailsData.data.success){
                            // this.fetchSiteCFData();
                            console.log(this.siteCFDeveloperMode);
                            swal({
                                type: "success",
                                title: 'Request Completed!',
                                text: "Developer mode settings has been updated.",
                            });
                        }
                    }
                }catch (e) {
                    swal({
                        title: "Something went wrong!",
                        html: 'Please try again!',
                        type: "error",
                        confirmButtonText: "Try Again!",
                        confirmButtonColor: "#EE8057"
                    });
                    this.$store.dispatch("async/stateUpdate", { state: true, text: '' });
                }

            },
            async changeSiteCF() {
                const account = this.account;
                try{
                    if(this.envType === 'live' && (account.cloudflare.apiKey !== null && account.cloudflare.apiKey !== '')
                        && (account.cloudflare.username !== null && account.cloudflare.username !== '')
                        && (account.cloudflare.zone_id !== null && account.cloudflare.zone_id !== '') ){
                        const zoneDetails = await this.$http.post('provider/zone_details', {
                            user_email: account.cloudflare.username,
                            api_key: account.cloudflare.apiKey,
                            zone_id: account.cloudflare.zone_id,
                            mode: (this.siteCF === 'enabled') ? 'false' : 'true'
                        });
                        const zoneDetailsData = zoneDetails.data;
                        if(zoneDetailsData.data.success){
                            // this.siteCF = (!zoneDetailsData.data.result.paused) ? 'enabled' : 'disabled';
                            swal({
                                type: "success",
                                title: 'Request Completed!',
                                text: "Cloud Flare zone settings has been updated.",
                            });
                        }
                    }
                }catch (e) {
                    swal({
                        title: "Something went wrong!",
                        html: 'Please try again!',
                        type: "error",
                        confirmButtonText: "Try Again!",
                        confirmButtonColor: "#EE8057"
                    });
                    this.$store.dispatch("async/stateUpdate", { state: true, text: '' });
                }
            },
            async fetchSiteCFData(account) {
                console.log('Fetching CF Data...');
                console.log(account);
                if(this.envType === 'live' && (account.cloudflare.apiKey !== null && account.cloudflare.apiKey !== '')
                    && (account.cloudflare.username !== null && account.cloudflare.username !== '')
                    && (account.cloudflare.zone_id !== null && account.cloudflare.zone_id !== '') ){
                    const zoneDetails = await this.$http.get('provider/zone_details?api_key=' + account.cloudflare.apiKey + '' +
                        '&user_email=' + account.cloudflare.username + '' +
                        '&zone_id=' + account.cloudflare.zone_id);
                    const zoneDetailsData = zoneDetails.data;
                    console.log(zoneDetailsData);
                    if(zoneDetailsData.data.developerMode.success){
                        this.siteCFDeveloperMode = zoneDetailsData.data.developerMode.result.value;
                    }
                    if(zoneDetailsData.data.siteCF.success){
                        this.siteCF = (!zoneDetailsData.data.siteCF.result.paused) ? 'enabled' : 'disabled';
                    }
                    console.log(this.siteCFDeveloperMode, this.siteCF);
                }
            },
            enableWPRocket() {
                this.$http.post('/utilities/wp-rocket', {
                    grant_type: 'token',
                    ip: this.account.ftp.host,
                    domain: (this.envType === 'live') ? this.account.domain : this.account.staging.domain
                }).then(() => {
                    swal('Enabled!', 'WP-Rocket settings enabled successfully!', 'success');
                }).catch(e => {
                    console.error(e);
                   swal('Error!', 'Error in enabling wp-rocket! Please contat support.', 'error');
                });
            },
            async fixPhpMyAdmin () {
                console.log(this.allAccounts);
                console.log(this.account);
                const hostName = this.allAccounts[this.account.planIndex].primary.hbHostname;
                this.$store.commit('mutateFixPhpMyAdminLoader', true);
                if(hostName) {
                    const stagingCloudFlareUserName = "justin@bigscoots.com";
                    const stagingCloudFlareApiKey = "b5762dad4a8b48e9bbd889ffbacc34ad901ca";
                    const stagingCloudFlareZoneId = "68f2452756f35ff08f47d469fd0c9c4b";
                    try{
                        await this.$http.post("dns/create", {
                            grant_type: "token",
                            cloudflare_email: stagingCloudFlareUserName,
                            cloudflare_api_key: stagingCloudFlareApiKey,
                            cloudflare_zone: stagingCloudFlareZoneId,
                            data: {
                                content: this.account.serverIP,
                                name: hostName,
                                priority: 10,
                                proxied: true,
                                ttl: 1,
                                type: "A"
                            }
                        });
                    }catch (e) {
                        console.log(e)
                    }
                }else {
                    console.error('Hostname is not found for this plan!!!');
                }
                await this.$http.post('/utilities/fix-php-my-admin', {
                    grant_type: 'token',
                    ip: this.account.serverIP,
                    firstName: (!this.fromCollaborator) ? this.user.firstName : this.supervisor.supervisorName,
                    lastName: (!this.fromCollaborator) ? this.user.lastName : this.supervisor.supervisorName,
                    email: (!this.fromCollaborator) ? this.user.email : this.supervisor.supervisorEmail,
                    UID: (!this.fromCollaborator) ? this.user.uid : this.supervisor.supervisorId,
                    collaborator: (!this.fromCollaborator) ? '0' : '1',
                    collaboratorUID: this.user.uid,
                    collaboratorEmail: this.user.email
                }).then(resp => {
                    swal('Fixing!', resp.data.msg, 'success');
                }).catch(() => {
                    swal('Error!', 'Something went wrong!', 'Please try again later.');
                    this.$store.commit('mutateFixPhpMyAdminLoader', false);
                })
            },
            async fixPermissions() {
                this.$store.commit('mutateFixPermissionsLoader', true);
                await this.$http.post('/utilities/fix-permissions', {
                    grant_type: 'token',
                    domain: (this.envType === 'live') ? this.account.domain : this.account.staging.domain,
                    ip: this.account.serverIP,
                    firstName: (!this.fromCollaborator) ? this.user.firstName : this.supervisor.supervisorName,
                    lastName: (!this.fromCollaborator) ? this.user.lastName : this.supervisor.supervisorName,
                    email: (!this.fromCollaborator) ? this.user.email : this.supervisor.supervisorEmail,
                    UID: (!this.fromCollaborator) ? this.user.uid : this.supervisor.supervisorId,
                    collaborator: (!this.fromCollaborator) ? '0' : '1',
                    collaboratorUID: this.user.uid,
                    collaboratorEmail: this.user.email
                }).then(resp => {
                    swal('Fixing!', resp.data.msg, 'success');
                }).catch(() => {
                    swal('Error!', 'Something went wrong!', 'Please try again later.');
                    this.$store.commit('mutateFixPermissionsLoader', true);
                })
            }
        }
    }
</script>

<style scoped>

</style>
